import { getMessages } from '../../../../../store/constants';

export const TYPE_SWITCHER_GANTT_CONTEXT_HINT = getMessages().getText('gantt_context_hints.gantt_type_switcher');
export const TYPE_SWITCHER_GANTT_CONTEXT_HINT_LARGE = getMessages().getText('gantt_context_hints.gantt_type_switcher.large');
